import Icon from "@/shared/ui/Icon";

function BackBtn({ onClick, className }: { onClick: () => void; className?: string }) {
  return (
    <button
      type="button"
      className={`bg-matched/85 hover:bg-matched/95 active:bg-matched text-gray/85 transition flex overflow-hidden font-bold uppercase text-xxs h-12 items-center rounded-2xl p-1 ${className}`}
      onClick={onClick}
    >
      <div className="p-0 h-10 aspect-square btn variant-solid-gradient">
        <Icon name="triangle-right" className="w-2.5 -scale-x-100" />
      </div>
      <div className="pr-4 pl-3">Назад</div>
    </button>
  );
}

export default BackBtn;
